import { Collapse, Divider } from "antd";
import { FC, ReactNode } from "react";

const Section: FC<{
  label: ReactNode;
  children?: ReactNode;
}> = ({
  label,
  children,
}) => {
  return (
    <>
      <Collapse
        ghost
        items={[
          {
            forceRender: true,
            key: 1,
            label: (
              <div className="flex select-none gap-1 font-semibold">
                {label}
              </div>
            ),
            children,
          },
        ]}
        defaultActiveKey={1}
        expandIconPlacement="end"
        classNames={{
          body: "pe-4! ps-4!",
        }}
      />
      <Divider className="m-0!" />
    </>
  );
};

export default Section;
